import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-checkbox" }
const _hoisted_2 = ["checked", "disabled"]
const _hoisted_3 = { class: "base-checkbox__wrap" }

import CheckboxActive from "@/icons/common/checkbox-active.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  isChecked: Boolean,
  disabled: Boolean,
},
  emits: ["toggle:select"],
  setup(__props, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("input", {
      type: "checkbox",
      checked: __props.isChecked,
      disabled: __props.disabled,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle:select')))
    }, null, 40, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CheckboxActive)
    ])
  ]))
}
}

})